// This is a bit hacky, but it's a simple way to get the CSRF token from the
// page without a lot of extra work. I'm sure there's a more React-way to do
// this, but ultimately, we're using this application on one single page.
export function token(): string | null | undefined {
  return document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
}
